import clsx from "clsx";

import { PrimaryButton } from "@components/v2";

interface Props {
  onClick: () => void;
}

export const EmptyState = ({ onClick }: Props) => {
  return (
    <div
      className={clsx(
        "h-full border border-v2-tertiary bg-v2-overlay-shadow-200 rounded",
        "shadow-[inset_0_0_20px] shadow-v2-black/10%",
        "flex items-center justify-center",
      )}
    >
      <div className="flex flex-col items-center justify-center">
        <div className="font-semibold text-sm mb-5">No metric selected</div>
        <PrimaryButton onClick={onClick}>
          <i className="fa-regular fa-plus" />
          ADD METRIC
        </PrimaryButton>
      </div>
    </div>
  );
};
